import styled from "styled-components";

const PagerBody = styled.div`
  padding-bottom: 15px;
`;
export default PagerBody;
